import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";
import BoShowAttachmentGallery from "./bo-show-attachment-gallery.jsx";

const BoShowOtherDocuments = () => {
    const {boData, verifySyncUrl} = useContext(BoShowContext);
    const otherDocumentsList = boData?.otherDocumentsList;

    if (!otherDocumentsList?.length) return null;

    return (
        <>
            {
                otherDocumentsList.map((documentItem, index) => (
                    <article key={documentItem?.itemId ?? index} className={"space-y-4"}>
                        <h2 className={"resume-title"}>DOCUMENTOS</h2>

                        <section className={"grid grid-cols-2 gap-2"}>
                            <p>Tipo: <span className={"info"}>{BoKeys[documentItem?.type] ?? documentItem?.type ?? ""}</span></p>
                            <p>Número / Nome: <span className={"info"}>{documentItem?.value ?? ""}</span></p>
                        </section>

                        {
                            !!documentItem?.attachs?.length &&
                            <BoShowAttachmentGallery
                                attachments={documentItem.attachs}
                                verifySyncUrl={verifySyncUrl}
                                titleMaker={() => `DOCUMENTO - ${BoKeys[documentItem?.type] ?? documentItem?.type ?? ""} ${documentItem?.value ?? ""}`}
                                descriptionField={false}
                            />
                        }
                    </article>
                ))
            }
        </>
    );
};

export default BoShowOtherDocuments;
